import { connect } from 'react-redux';
import UIDateFormater, { DateType } from '../../containers/UIhelper/UIDateFormater';

import * as actionsDmas from '../../actions/DmasActions';
import DmaHistoryModal from "../../components/Modals/DmaHistoryModal";
import useProjectTimezone from '../../hooks/useProjectTimeZone';

const mapStateToProps = (state, ownProps) => {
  const {
   isFetchDmaData,
   selectedDmaId,
   selectedDmaData,
   selectedDmaCustomer,
   isDataVisible
  } = state.leaksList.dmas;

  const timeZone = state.local.timeZone;
  const projectTimezone = useProjectTimezone();

  let valuesX = [];
  let valuesY = [];

  if(selectedDmaData != null) {
    selectedDmaData.forEach((dmaData) => {
      valuesX.push(UIDateFormater(dmaData.relevantToDate, DateType.DATE, timeZone, projectTimezone));
      valuesY.push(dmaData.sensitivity);
    });
  }

  const plotData = [{
    x: valuesX,
    y: valuesY,
    mode: 'lines+markers',
    type: 'scatter'
}];

  return Object.assign({}, ownProps, {
     isFetchDmaData,
     selectedDmaCustomer,
     selectedDmaId,
     isDataVisible,
     plotData
  });
};

const mapDispatchToProps = (dispatch) => {
  return {
    onClose: () => {
      dispatch(actionsDmas.setDisplayDmaData(false));
    }
  };
};

const CDmaHistoryModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(DmaHistoryModal);

export default CDmaHistoryModal;
